import Rest from '@/services/Rest';

/**
 * @typedef {DomainPixelService}
 */
export default class DomainPixelService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/domain'
}